// Svelte 5 no longer needs svelte/store imports for basic reactivity

function loadVoicesFromLocalStorage() {
    let voices = JSON.parse(localStorage.getItem("cc-voice-defaults")) || [];
    return voices;
}

// Create reactive state for voices
export const voiceState = $state(loadVoicesFromLocalStorage());